// extracted by mini-css-extract-plugin
export default {"defaultTextInput":"DefaultTextInput_defaultTextInput__tAsYq","inputLabel":"DefaultTextInput_inputLabel__PGCLc"};